<div class="fulfill-side-panel-batch">
  <!-- HEADER -->
  <div class="fulfill-side-panel-batch__row">
    <div class="fulfill-side-panel-batch__row__back-button" (click)="closePanel()">
      <img src="../../../../../../../assets/images/left_chevron.png" alt="" />
    </div>
    <app-edit-batch-name [shopMetadata]="shopMetadata" [batch]="batch">
      <batch-fulfillment-status-tag [batch]="batch"></batch-fulfillment-status-tag>
    </app-edit-batch-name>
    @if (isOnTrial) {
      <pdq-tag
        class="fulfill-side-panel-batch__row-trial-tag"
        value="Test mode"
        variant="quaternary"
        mode="rect"
        size="large"></pdq-tag>
    }
    <div class="fulfill-side-panel-batch__row__print align-right">
      <span>
        Printed {{ batch.printCounter }} times{{
          batch.printCounter ? ', last on ' + getPrintFormatted(batch.lastPrint) : ''
        }}
      </span>
      <pdq-dropdown
        placeholder="Print"
        icon="print"
        mode="ghost"
        type="actionList"
        [align]="'right'"
        [options]="printOptions"
        [sections]="printSections"
        (onChange)="print($event, batch.id)"></pdq-dropdown>
    </div>
    <p class="fulfill-side-panel-batch__row__print__mobile">
      Printed {{ batch.printCounter }} times{{
        batch.printCounter ? ', last on ' + getPrintFormatted(batch.lastPrint) : ''
      }}
    </p>
  </div>

  <div #bannerContainer class="banners-container">
    <!-- WARNING BANNER -->
    @if (inWarningOrderIds.length) {
      <fulfill-side-panel-update-banner [batch]="batch"></fulfill-side-panel-update-banner>
    }

    <!-- ERRORS BANNER -->
    @if (batch?.errors?.length) {
      <pdq-banner variant="danger" bannerTitle="Error banner">
        <ul class="fulfill-side-panel-batch__errors">
          @for (error of batch.errors; track error) {
            <li>{{ error }}</li>
          }
        </ul>
      </pdq-banner>
    }

    <!-- ADDED TO BATCH BANNER -->
    @if (addedToBatchOrdersNumbers?.length) {
      <pdq-banner
        variant="regular"
        [bannerTitle]="
          (addedToBatchOrdersNumbers.length === 1 ? 'Order ' : 'Orders ') +
          addedToBatchOrdersNumbers.join(', ') +
          ' added to batch'
        "></pdq-banner>
    }

    <!-- TRIAL BANNER -->
    @if (isOnTrial) {
      <pdq-banner
        variant="attention"
        bannerTitle="You're in trial mode"
        button="Pick plan"
        [content]="getTrialBannerText()"
        (onButtonClick)="pickPlan()"></pdq-banner>
    }
  </div>

  <!-- BATCH INFO -->
  <div class="fulfill-side-panel-batch__row scan">
    <div style="width: 100%">
      <pdq-input
        class="scan_input"
        label="Review order"
        placeholder="Scan or enter label no."
        [value]="searchString"
        (onKeyup)="setOrderId($event)"
        (onEnter)="scanOrder()"
        [autofocus]="true"></pdq-input>
      <ng-template #scannedOrderMultipleResults> </ng-template>
    </div>

    <pdq-button
      class="scan-btn"
      label="Go to order"
      icon="scan"
      variant="light"
      [loading]="isGoToOrderButtonLoading"
      (onClick)="scanOrder()"></pdq-button>
  </div>
  <div class="fulfill-side-panel-batch__row running">
    @if (addedOrders?.length) {
      <pdq-tabs-group variant="batch" leftMargin="none" (onChange)="onChangeTab($event)">
        <pdq-tab value="all" label="All ({{ batch.orders?.length }})"></pdq-tab>
        <pdq-tab value="added" label="Added to batch ({{ addedOrders?.length }})"></pdq-tab>
      </pdq-tabs-group>
    }
    <div class="align-right">
      <span>{{ batch.orders.length }} orders</span>
      <span>{{ batch.numberOfPackages }} packages</span>
      <span>{{ getNumberOfItems() }} items</span>
    </div>
  </div>

  <!-- BATCHES TABLE -->
  <fulfill-side-panel-batch-table
    [batch]="batch"
    [inWarningOrderIds]="inWarningOrderIds"
    [bannersHeight]="bannersHeight"
    [filteredOrders]="filteredOrders"></fulfill-side-panel-batch-table>
</div>
